import React from 'react'
import clsx from 'clsx'

import Info from '../../../../../components/atoms/Info'

import useStyles from './styles'

type InformationProps = {
  info: string
  className?: string
}

const Information: React.FC<InformationProps> = ({ info, className }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <Info text={info} />
    </div>
  )
}

export default Information
